import { useTheme } from '@mui/material/styles';

import { DELIVERY_SIGN_OUT } from './constants';

import { CUSTOM } from '../Modal/modalTypes';
import ListActions from '../Table/ListActions';

export const deliveryActions = (setModalData) => {
  const theme = useTheme();

  const actions = {
    Header: 'Actions',
    id: 'actions',
    fixed: 'right',
    sortable: false,
    width: 160,
    accessor: ({ signOutData, building, unit, recipient }) => {
      if (!signOutData?.id) return null;

      const deliverySignOutModalProps = {
        modalName: DELIVERY_SIGN_OUT,
        modal: {
          modalType: CUSTOM,
          modalProps: {
            title: 'delivery sign out',
            maxWidth: 'md',
          },
        },
        unit: {
          parentProperty: building,
          id: unit,
          recipientId: recipient?.id,
        },
        onModalClose: () => setModalData({}),
      };

      const signOutAction = [
        {
          label: 'Sign Out',
          color: theme.palette.primary.main,
          onClick: () => setModalData(deliverySignOutModalProps),
        },
      ];

      const signOutCompleted = [
        {
          label: 'Sign Out Complete',
          color: theme.palette.grey[400],
          disabled: true,
          onClick: () => {},
        },
      ];

      const actions = signOutData?.signedOutAt
        ? signOutCompleted
        : signOutAction;

      return <ListActions actions={actions} isFullWidth />;
    },
  };

  return actions;
};
